/* eslint-disable camelcase */
import React, { Suspense, useState } from 'react';
import { MapPin } from 'react-feather';
import { useTranslation } from 'react-i18next';

import toast from 'react-hot-toast';
import Modal from './Modal';
import Input from './Input';
import Button from './Button';
import {
  classNames,
  getLocation,
  getLocationByDepartment,
} from '../util/functions';
import { useLocation } from '../Provider/LocationProvider';
import { useRegion } from '../Provider/RegionProvider';
import { getLocationConfig } from '../static/region-data';
import DropdownLocationForm from './DropdownLocationForm';
import useWindowDimensions from '../hooks/useWindowDimensions';
// import ReactSelect from './ReactSelect';
const ReactSelect = React.lazy(() => import('./ReactSelect'));
const distanceData = ['25 m.', '50 m.', '100 m.', '500 m.'];

/* =============================================================================
<LocationButton />
============================================================================= */

const LocationButton = ({
  value,
  showDistance,
  onChange,
  locButtonStyle,
  locTitleStyle,
}) => {
  const [code, setCode] = useState('');
  const [distance, setDistance] = useState('');
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const { location, saveLocation } = useLocation();
  const { width } = useWindowDimensions();
  const { country } = useRegion();
  const { t } = useTranslation();

  const toggleModal = () => {
    setModalVisible(!modalVisible);
  };

  const _handleApply = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      if (!code) {
        toast.error(t('location.enterCode'));
        return;
      }
      const result = await getLocation(code, country?.name);
      if (result && distance) {
        const loc = {
          ...result,
          radius: distance,
        };
        onChange(loc);
        await saveLocation(loc);
      } else {
        onChange(result);
      }

      toggleModal();
    } catch (err) {
      console.log('Error', err);
      if (
        err?.message ===
        'Geocoding request failed: Geocoding failed: undefined. Server returned status code ZERO_RESULTS.'
      ) {
        toast.error(t('location.zipCodeNotFound'));
      } else {
        toast.error(err?.message);
      }
    } finally {
      setLoading(false);
    }
  };
  const _handleApplyDropdown = async (data) => {
    try {
      setLoading(true);
      const result = await getLocationByDepartment(data, country?.name);
      onChange(result);
      await saveLocation(result);

      toggleModal();
    } catch (err) {
      console.log('Error', err);
      toast.error(err?.message);
    } finally {
      setLoading(false);
    }
  };

  const truncateAddressPart = (value, maxChars = 10) => {
    if (!value) return '';

    const text = value.trim();
    if (text.length <= maxChars) return text;

    return `${text.slice(0, maxChars).trimEnd()}...`;
  };

  const checkLabel = () => {
    if (location?.filteredAddress) {
      if (location?.radius) {
        return `${location.filteredAddress} - ${location?.radius} `;
      }
      const formattedAddress = location.filteredAddress
        .split(',')
        .map((part) => truncateAddressPart(part))
        .join(', ');
      if (width < 640) {
        return truncateAddressPart(location.department);
      }
      return formattedAddress;
    }

    return config.useDropdownForm
      ? t(config.buttonLabel || 'location.selectLocation')
      : t('location.zipCode');
  };
  const config = getLocationConfig(country?.code);

  return (
    <div className={classNames('flex-1', locButtonStyle)}>
      <button
        type='button'
        onClick={toggleModal}
        className='flex space-x-2 items-center justify-between w-full '
      >
        <p className={classNames('text-white xsm:text-sm', locTitleStyle)}>
          {checkLabel()}
        </p>
        <MapPin color='#fff' size={25} />
      </button>
      <Modal
        heading={t('location.title')}
        visible={modalVisible}
        onClose={toggleModal}
        customStyles='overflow-visible'
      >
        <div className='flex flex-col  justify-between space-y-5'>
          {config.useDropdownForm ? (
            <>
              <DropdownLocationForm
                departments={config.departments}
                onApply={_handleApplyDropdown}
                loading={loading}
                isMultiSelect
                selectedDepartment={location?.department || ''}
                selectedDistrict={
                  location?.districts || location?.district || []
                }
              />
            </>
          ) : (
            <>
              <Input
                isFocused
                value={code}
                type='number'
                label={t('location.zipCode')}
                placeholder={t('location.enterZipCode')}
                onChange={(e) => setCode(e.target.value)}
              />
              {showDistance && (
                <Suspense
                  fallback={
                    <div className='p-2 text-sm'>{t('common.loading')}...</div>
                  }
                >
                  <ReactSelect
                    label={t('location.distance')}
                    value={distance}
                    items={distanceData}
                    onChange={setDistance}
                  />
                </Suspense>
              )}
              <Button
                title={t('common.apply')}
                size='block'
                loading={loading}
                onClick={_handleApply}
              />
            </>
          )}
          {/* {showDistance && (
            <Suspense
              fallback={
                <div className='p-2 text-sm'>{t('common.loading')}...</div>
              }
            >
              <ReactSelect
                label={t('location.distance')}
                value={distance}
                items={distanceData}
                onChange={setDistance}
              />
            </Suspense>
          
          )} */}

          {/* {showDistance && (
            <ReactSelect
              label='Distance'
              value={distance}
              items={distanceData}
              onChange={setDistance}
            />
          )} */}
        </div>
      </Modal>
    </div>
  );
};

/* Export
============================================================================= */
export default LocationButton;
